// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elevation-1[data-v-4858ad72]{margin:20px;text-align:center}.v-stepper[data-v-4858ad72]{direction:rtl!important}.v-stepper[data-v-4858ad72] .v-stepper__header{-webkit-box-shadow:none!important;box-shadow:none!important;direction:rtl!important}", ""]);
// Exports
module.exports = exports;
